// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import { RadioPicker, RadioOption } from '../../../FlowConfigurationInputs/RadioPicker/RadioPicker';

// Import Recoil
import { initialActions, saveAvailable, changedFields } from "../../../../recoil-store/recoil-state";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';

/**
 * @Description this page Datatable Library's Limit Rows Action configuration form
 * @Param       action - object 
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render 
 * @Returns     div element
 * @Author      Abdullah Onur Yeşil
 */
export default function LimitRows({ action, variables, setOpenVariable }) {
    const [columnTab, setColumnTab] = useState('index');

    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.';
    const l = label + 'COMBINE-TABLES.';
    const excelLabel = "CONTENT.CONFIGURATION-FORM.EXCEL.COPY.";

    useEffect(() => {
        if (!action.fields.columnTab) {
            action.fields.columnTab = { value: 'index' }
        }

        setColumnTab(action.fields.columnTab.value);
    }, [])

    const handleChange = (e) => {
        let value = e.target.value;

        const field = initialActionsData[action.id]?.fields["columnTab"];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated("columnTab", action, oldValue, value, setSaveAvailable, setChangeFields, changedFieldsState);

        action.fields.columnTab = { value };
        if (value === 'index') {
            delete action.fields.columnName;
        } else {
            delete action.fields.columnIndex;
        }
        setColumnTab(value);
    }

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(l + 'FIRST-DATA')} is_required />
                <VariablePicker action={action} inputName="firstData" variables={variables}
                    setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>

            <div className="conf-field-container">
                <FieldLabel name={t(l + 'SECOND-DATA')} is_required />
                <VariablePicker action={action} inputName="secondData" variables={variables}
                    setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>

            <div className="conf-field-container">
                <RadioPicker value={columnTab} onChange={handleChange}>
                    <RadioOption value="index" >
                        <FieldLabel name={t(label + 'COLUMN-INDEX')} is_required={columnTab === 'index'} />
                        <TextInput action={action} inputName="columnIndex" variables={variables}
                            setOpenVariable={setOpenVariable} disabled={columnTab !== 'index'}
                            isRequired={columnTab === 'index'} fieldType="string-single-column" displayName={t(label + 'COLUMN-INDEX')} hideRequired />
                        <small className="conf-field-desc"><em>{t(label + 'COLUMN-INDEX-EG')}</em></small>
                    </RadioOption>

                    <RadioOption value="name" classes={"m-t-20"}>
                        <FieldLabel name={t(excelLabel + 'COLUMN-NAME')} is_required={columnTab === 'name'} />
                        <TextInput action={action} inputName="columnName" variables={variables}
                            setOpenVariable={setOpenVariable} disabled={columnTab !== 'name'}
                            isRequired={columnTab === 'name'} fieldType="string" displayName={t(excelLabel + 'COLUMN-NAME')} hideRequired />
                        <small className="conf-field-desc"><em>{t(label + 'COLUMN-NAME-EG')}</em></small>
                    </RadioOption>
                </RadioPicker>
            </div>


            <div className="conf-field-container">
                <FieldLabel name={t(label + 'ASSIGN-VALUE')} is_required />
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable}
                    filter={"data table"} isRequired hideRequired />
                <small className='conf-field-desc'><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>

            </div>
        </div>
    )
}